<template>
    <div class="client-item">
        <span class="w-1/5 flex items-center">
            <span class="ml-2">{{ client.name }} {{ client.lastname }}</span>
        </span>
        <span class="w-1/5 flex items-center">
            <span class="ml-2">{{ client.company || '--' }}</span>
        </span>
        <span class="w-1/6 flex items-center">
            <span class="ml-2">{{ client.ico || '--' }}</span>
        </span>
        <span class="w-1/6 flex items-center">
            <span class="ml-2">{{ client.phone || '--' }}</span>
        </span>
        <span class="w-1/5">
            {{ createdAt }}
        </span>
        <span class="ml-auto mr-4">
            <md-button :to="{'name': 'clients.detail', params: {clientId: client.id}}" class="md-dense md-icon-button md-primary">
                <md-icon>edit</md-icon>
            </md-button>
        </span>
    </div>
</template>

<script>
    import Avatar from "../../components/Avatar";
    export default {
        name: "ClientItem",
        components: {Avatar},
        props: {
            client: {
                type: Object,
                required: true
            }
        },
        computed: {
            createdAt() {
                return moment.unix(this.client.created_at).format("DD.MM.YYYY [o] HH:mm")
            }
        }
    }
</script>

<style lang="scss">
    .client-list {
        .client-item {
            @apply bg-white my-3 py-2 px-4 rounded-full flex items-center text-gray-700 shadow;
            &:hover{
                @apply shadow-md;
            }
            
            .dot {
                @apply bg-gray-300 w-3 h-3 rounded-full block;
                &.active {
                    @apply bg-green-400;
                }
            }
        }
    }
</style>